import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import { ENV_CONFIG } from '@ps/core-config';
import { withLoading } from '@ps/core-loading';

import { CreateTagRequest, Tag } from '@ps/feature-tags';
import { TagMapper } from './mappers/tag.mapper';
import { TagPayloadMapper } from './mappers/tag.payload.mapper';
import { TagDto } from './dtos/tag.dto';

@Injectable({ providedIn: 'root' })
export class TagsApi {
  private readonly _env = inject(ENV_CONFIG);
  private readonly _http = inject(HttpClient);
  private readonly _tagMapper = new TagMapper();
  private readonly _tagPayloadMapper = new TagPayloadMapper();

  private readonly _baseUrl = this._env.pureSpectrum.url;

  public getTags(): Observable<Tag[]> {
    return this._http
      .get<TagDto[]>(`${this._baseUrl}/tags`, {
        context: withLoading('content'),
      })
      .pipe(map((dtos) => this._tagMapper.fromDtoList(dtos)));
  }

  public createTag(request: CreateTagRequest): Observable<Tag> {
    return this._http
      .post<TagDto>(
        `${this._baseUrl}/tags`,
        this._tagPayloadMapper.toPayload(request),
      )
      .pipe(map((dto) => this._tagMapper.fromDto(dto)));
  }
}
